module.exports = __webpack_public_path__ + "img/img-avatar-03.1e1333c2.png";